/* eslint-disable no-prototype-builtins */
import { generalDictionary } from "./dictionaries/general.js";
import { homeDictionary } from "./dictionaries/home.js";
import { productsDictionary } from "./dictionaries/products.js";
import { detailsDictionary } from "./dictionaries/details.js";
import { detailFundsDictionary } from "./dictionaries/detailFunds.js";
import { instrumentNamesDictionary } from "./dictionaries/instruments.js";

const locale = window.location.pathname.includes("/en/") ? "en" : "es";
// const locale = 'en';
const dictionaries = {
    ...homeDictionary,
    ...productsDictionary,
    ...detailsDictionary,
    ...detailFundsDictionary,
    ...generalDictionary,
    ...instrumentNamesDictionary,
};

export function __(key) {
    if (dictionaries.hasOwnProperty(key)) {
        return dictionaries[key][locale];
    } else {
        return key;
    }
}
